import { useState, useEffect } from "react";
import { SwitchContainer } from "../../style/Switch/index";

const Switch = ({ onChange, checked }) => {
  const [isChecked, setIsChecked] = useState(checked || false);

  const handleClick = () => {
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    onChange(newChecked);
    console.log(newChecked);
  };

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  return (
    <SwitchContainer>
      <div className={`switch ${isChecked ? "active" : ""}`} onClick={handleClick}>
        <div className="switch-handle" />
      </div>
    </SwitchContainer>
  );
};

export default Switch;
